import { SolViewId, SolViewOptions } from '@sol/components';

export interface AsmTagFilterOptions extends SolViewOptions {
  readonly tagCategories?: readonly string[];
}

export class AsmSearchViewId {
  public static readonly tagLabelEdit = SolViewId.of<AsmTagFilterOptions>('tagLabelEdit');
}
